

































































































































import { NoUndefinedVariables } from 'graphql/validation/rules/NoUndefinedVariables';
import Vue from 'vue'

export default Vue.extend({
  //load the counseling questions for property
  props: {
    caseId: {
      type: String,
      required: true,
    },
    timeOfMeasurement: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      diagnosis: 'accept',
    }
  },
  computed: {
    counselingQuestions(): any {
      const data = this.$store.getters['counselingQuestions/filterBy']({
        case_id: this.caseId,
        time_of_measurement: this.timeOfMeasurement,
      })
      if (data && data.length > 0) {
        return data[data.length - 1]
      }
      return undefined
    },
  },
})
